import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Inicio', path: '/' },
  { label: 'Sobre Nosotros', path: '/sobre-nosotros' },
  { label: 'Donar', path: '/donar' },
  { label: 'Contacto', path: '/contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/96 backdrop-blur-md' : 'bg-transparent'
      }`}
      style={{ height: '80px' }}
    >
      <nav className="h-full flex items-center justify-between px-6 md:px-14">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/04072f05a7ab05cce1b5fc08d2859ba4/b0395c77c26132b4275f62d8aa13c8ff.png"
            alt="Fundación Frais - Ingeniería Circular Infinita"
            className="w-auto object-contain"
            style={{ height: '68px', filter: scrolled ? 'none' : 'drop-shadow(0 2px 10px rgba(0,0,0,0.4))' }}
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`text-xs font-semibold tracking-widest uppercase transition-colors duration-300 relative group cursor-pointer ${
                    scrolled
                      ? isActive
                        ? 'text-[#2e7d32]'
                        : 'text-gray-600 hover:text-[#2e7d32]'
                      : isActive
                      ? 'text-white'
                      : 'text-white/90 hover:text-white'
                  }`}
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {link.label}
                  <span
                    className={`absolute -bottom-1 left-0 h-0.5 bg-[#66bb6a] transition-all duration-300 ${
                      isActive ? 'w-full' : 'w-0 group-hover:w-full'
                    }`}
                  />
                </Link>
              </li>
            );
          })}
        </ul>

        {/* CTA Button — Cotizar */}
        <Link
          to="/contacto"
          className={`hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full text-xs font-bold tracking-wider uppercase hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap ${
            scrolled
              ? 'bg-[#2e7d32] text-white hover:bg-[#1b5e20]'
              : 'bg-white text-[#2e7d32] hover:bg-white/90'
          }`}
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <i className={`ri-price-tag-3-fill ${scrolled ? 'text-[#a5d6a7]' : 'text-[#2e7d32]'}`}></i>
          Cotizar
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i
            className={`text-2xl transition-colors duration-300 ${
              scrolled ? 'text-[#2e7d32]' : 'text-white'
            } ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
          ></i>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-white/98 backdrop-blur-md transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <ul className="flex flex-col py-4">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="block px-8 py-4 text-xs font-semibold tracking-widest uppercase text-[#2e7d32] hover:bg-[#f1f8e9] transition-colors cursor-pointer"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li className="px-8 pt-2 pb-4 flex flex-col gap-2">
            <Link
              to="/contacto"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-full bg-[#2e7d32] text-white text-xs font-bold tracking-wider uppercase cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              <i className="ri-price-tag-3-fill text-[#a5d6a7]"></i>
              Cotizar Proyecto
            </Link>
            <Link
              to="/donar"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-full border border-[#2e7d32] text-[#2e7d32] text-xs font-bold tracking-wider uppercase cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              <i className="ri-heart-fill text-[#66bb6a]"></i>
              Donar Ahora
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}
